// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3.5 4.75H12.5C13.6 4.75 14.5 5.65 14.5 6.75V12C14.5 13.1 13.6 14 12.5 14H3.5C2.4 14 1.5 13.1 1.5 12V6.75C1.5 5.65 2.4 4.75 3.5 4.75Z',
  'M5.5 4.75V3.5C5.5 2.67 6.17 2 7 2H9C9.83 2 10.5 2.67 10.5 3.5V4.75',
  'M4.3 4.75V14M11.7 4.75V14',
  'M8 8.07V10.68M6.7 9.38H9.3',
];
